var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.tourmode ? 'right-pos' : '',staticStyle:{"display":"none"},attrs:{"id":"copyright-watermark"}},[_vm._v(" www.ironatlas.com "),_c('strong',{staticClass:"cw-comp d-block"},[_vm._v("2019 Vifor Pharma")]),_vm._v(" "+_vm._s(_vm.$t('cp_watermark'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }